/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-08-10 14:28:41
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-18 09:06:43
 */
var fs = window.fs;
let filecache = []
/**
 * 检查本地文件是否存在，存在则返回文件信息
 * @param {*} param0 
 * @returns 
 */
export const checkfileexist = ({ path }) => {
  let file //= filecache.find(file0 => file0.path === path)
  // if (!file) {
  try {
    let stats = fs.statSync(path);//如果文件已存在读取文件信息
    if (stats) {//如果文件已经存在并且已经下载按成则跳过该文件 
      file = {
        path,
        process: 100,
        filesize: stats.size
      }
      // filecache.push(file)
    }
  } catch (err) {

  }
  // }  
  return file || { process: 0 }
}
export const addfilecache = ({ path, process, filesize }) => {


}

